module.exports = __webpack_public_path__ + "static/media/join-barn-family-three.3ce6dd38.png";